<template>
  <div v-if="visible">
    <div class="overlay z-index-overlay"></div>
    <b-popover
      ref="popoverMenuTooltip"
      :target="target"
      :placement="placement || 'auto'"
      :show.sync="visible"
      :key="keyTooltipRender"
      custom-class="menu-tooltip"
      :disabled="true"
    >
      <feather-icon icon="XIcon" size="18" class="close-icon-menu-tooltip" @click="closeTooltip"/>
      <div class="img-menu-tooltip justify-self-center text-center">
        <img :src="img" width="80" class="m-1"/>
      </div>
      <div class="div-line-menu-tooltip"></div>
      <h1 class="title-menu-tooltip">{{ title }}</h1>
      <p class="p-menu-tooltip">{{ text }}</p>
      <div class="button-container-menu-tooltip">
        <b-button @click="doNotShowAgain" size="sm" class="button-dont-show-menu-tooltip" variant="none">No volver a mostrar</b-button>
        <b-button @click="goToRoute" size="sm" class="button-show-menu-tooltip" variant="none">Echar un vistazo</b-button>
      </div>
    </b-popover>
  </div>
</template>

<script>
export default {
  props: {
    id: {
      type: String,
      required: true
    },
    target: {
      type: String,
      required: true
    },
    text: {
      type: String,
      required: true
    },
    placement: {
      type: String,
      required: false
    },
    title: {
      type: String,
      required: true
    },
    img: {
      type: String,
      required: false
    },
    routeRedirect: {
      type: String,
      required: false
    },
    routeRedirectParams: {
      type: Object,
      required: false
    }
  },
  data() {
    return {
      visible: true,
      keyTooltipRender: 0
    }
  },
  methods: {
    showTooltip() {
      this.visible = true
      this.keyTooltipRender++
      // Encuentra el elemento con el ID 'app'
      const appElement = document.getElementById('app')
      // Crea un nuevo div
      const overlayDiv = document.createElement('div')
      // Agrega una clase al div
      overlayDiv.classList.add('overlay-modal-menu')
      // Inserta el nuevo div justo debajo del elemento 'app'
      appElement.parentNode.insertBefore(overlayDiv, appElement.nextSibling)
    },
    goToRoute() {
      this.closeTooltip()
      // Verificar si ya está en la ruta de destino
      if (this.$route.name === this.routeRedirect && JSON.stringify(this.$route.params) === JSON.stringify(this.routeRedirectParams || {})) {
        return
      }
      // Si no, navega a la ruta
      this.$router.push({ name: this.routeRedirect, params: this.routeRedirectParams })
    },
    closeTooltip() {
      const overlayDiv = document.querySelectorAll('.overlay-modal-menu')
      if (overlayDiv.length) {
        document.querySelectorAll('.overlay-modal-menu').forEach(el => el.remove()) // Elimina el div del DOM
      }
      this.visible = false
      this.keyTooltipRender++
    },
    doNotShowAgain() {
      const storedData = JSON.parse(localStorage.getItem(this.id))
      if (storedData) {
        storedData.doNotShowAgain = true
        localStorage.setItem(this.id, JSON.stringify(storedData))
      }
      this.closeTooltip()
    }
  }
}
</script>

<style lang='scss'>
@import url('https://fonts.googleapis.com/css?family=Roboto:600,100,100italic,300,300italic,400italic,500,500italic,700,700italic,900italic,900');
.menu-tooltip {
  background: #fff !important;
  width: 325px !important;
  height: 354 !important;
  min-width: 325px !important;
  min-height: 354 !important;
  max-width: 325px !important;
  max-height: 354 !important;
  border-radius: 1rem !important;
  margin-left: 12em !important;
  z-index: 99999 !important;
  font-family: roboto !important;
  > div {
  border: none !important;
  }
}
@media (max-width: 767px) {
  .menu-tooltip {
    transform: none !important;
    margin-left: 0 !important;
    min-width: 325px !important;
    min-height: 354 !important;
    max-width: 325px !important;
    max-height: 354 !important;
  }
  .arrow {
    display: none !important;
  }
}
.overlay-modal-menu {
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  background: rgba(0, 0, 0, 0.5); /* Fondo semi-transparente */
  z-index: 1000; /* Asegura que esté encima de todo */
}

.img-container {
  display: flex;
  justify-content: center;
  width: 200px;
  border-bottom: 1px solid #000;
}

.close-icon-menu-tooltip {
  position: absolute;
  width: 24px;
  height: 24px;
  right: 12px;
  top: 12px;
  cursor: pointer;
}

.title-menu-tooltip {
  font-weight: 600 !important;
  font-size: 16px !important;
  color: rgba(40, 40, 40, 1) !important;
  letter-spacing: 0% !important;
}

.p-menu-tooltip {
  font-weight: 300 !important;
  font-size: 14px !important;
  line-height: 100% !important;
  margin-bottom: 24px;
  color: rgba(40, 40, 40, 0.7) !important;
}

.div-line-menu-tooltip {
  border-bottom: 1px solid #2C3F6F;
  width: 100%;
  margin-top: 12px;
  margin-bottom: 24px;
}

.button-container-menu-tooltip {
  display: flex;
  justify-content: space-between;
  margin: 8px;
}

.button-show-menu-tooltip {
  font-weight: 300 !important;
  font-size: 14px !important;
  border-radius: 6px !important;
  padding: 10px !important;
  gap: 4px !important;
  background: linear-gradient(90deg, #32ADEC 0%, #685FE3 100%);
  color: #fff !important;
}

.button-dont-show-menu-tooltip {
  font-weight: 300 !important;
  font-size: 14px !important;
  line-height: 100% !important;
  border-radius: 6px !important;
  padding: 10px !important;
  gap: 4px !important;
  background: none;
  color: rgba(25, 103, 210, 1) !important;
}
.z-index-overlay {
  z-index: 9999 !important;
}
</style>
